import {
  AddOutlined,
  EditOutlined,
  RemoveRedEyeOutlined,
} from "@material-ui/icons";
import {
  Button,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Paper,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CVService } from "../../../service/CVService";
import { useNavigate } from "react-router-dom";
import CVForm from "./cv/forms/CVForm";
import AppButton from "../shares/AppButton";
import useToast from "../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import useConfirm from "../../../hooks/useConfirm";
import AuthService from "../../../service/AuthService";
import { minWidth } from "@mui/system";

const ListCV = ({ selection = false, id_type, handleSelectedCV }) => {
  const [cvLists, setCVList] = useState([]);
  const navigate = useNavigate();
  const [cvFormOpen, setCVFormOpen] = useState(false);
  const [currentIdCV, setCurrentIdCV] = useState(null);
  const [filtre, setFiltre] = useState({});
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleEditCV = (id) => {
    if (selection)
      AuthService.navigate(`/mon-profile/cv?id_identite=${id}`, selection);
    else navigate(`/mon-profile/cv?id_identite=${id}`);
  };
  const handleFetchCVList = () => {
    CVService.getCVList(filtre).then((res) => {
      if (res && res.data) {
        setCVList(res.data);
      }
    });
  };

  const handleUseCV = (id_type, identite) => {
    handleSelectedCV(id_type, identite);
  };

  const duplicateCV = (id_type, id_identite) => {
    openConfirmDialog("Confirmation", "Voullez vous dupliquer ce CV?", () => {
      handleDuplicateCV(id_type, id_identite);
    });
  };

  const handleDuplicateCV = (id_type, id_identite) => {
    CVService.duplicateCV(id_type, id_identite).then((res) => {
      if (res && res.success) {
        handleFetchCVList();
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleOpenCVForm = (id_cv = null) => {
    setCVFormOpen(true);
    setCurrentIdCV(id_cv);
  };

  const handleFormClose = () => {
    setCVFormOpen(false);
  };

  const table_colonne = [
    {
      field: "file_cv",
      headerName: "Fichier",
      flex: 1,
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "Date_creation",
      headerName: "Date de création",
      flex: 0.5,
      minWidth: 150,
    },
    /* {
      field: "email",
      headerName: "Adresse email",
      flex: 1,
      minWidth: 150,
    }, */
    {
      field: "reference",
      headerName: "Réference",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Dupliquer cv"
              color="secondary"
              onClick={(e) => duplicateCV(0, params.row.id_identite)}
            >
              <ContentCopyIcon />
            </IconButton>
            {/* <IconButton
              title="Modifier cv"
              color="primary"
              onClick={(e) => handleEditCV(params.row.id_identite)}
            >
              <EditOutlined />
            </IconButton> */}
            <IconButton
              title="Afficher cv"
              color="primary"
              onClick={(e) => handleEditCV(params.row.id_identite)}
            >
              <RemoveRedEyeOutlined />
            </IconButton>
            {selection && (
              <Button
                sx={{ ml: 0.5 }}
                disabled={params.row.id_type > 0}
                title="Utiliser ce cv"
                color="primary"
                variant="contained"
                size="small"
                onClick={(e) => handleUseCV(id_type, params.row)}
              >
                Utiliser
              </Button>
            )}
          </Grid>
        );
      },
    },
  ];

  const handleConfirmCreationNewCV = () => {
    CVService.insertCV(null).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        //handleFetchCVList();
        navigate(`/mon-profile/cv?id_identite=${res.data.id_identite}`);
      }
    });
  };

  const handleCreateNewCV = () => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous creer un nouveau CV?",
      () => {
        handleConfirmCreationNewCV();
      }
    );
  };

  useEffect(() => {
    handleFetchCVList();
  }, []);

  return (
    <>
      <DialogComponent />
      <Toast />
      <CVForm
        open={cvFormOpen}
        onFormClose={handleFormClose}
        id_cv={currentIdCV}
      />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Liste des CVs"
              action={
                <Grid mr={2}>
                  <AppButton
                    size={"medium"}
                    text={"Nouveau"}
                    onClick={(e) => handleCreateNewCV()}
                    variant={"outlined"}
                    icon={<AddOutlined />}
                  />
                </Grid>
              }
            />
            <Grid container>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                rows={cvLists}
                getRowId={(row) => row.id_identite}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default ListCV;
